import Vue from "vue";

export default {
    statistics(range, target=null) {
        return Vue.http.get(`statistics?from=${range.from}&to=${range.to}&target=${target || ''}`);
    }
}